module.exports = __webpack_public_path__ + "img/portfolio-full-width.24fbf3c3.png";